import { useEffect, useState } from 'react';

type AnchorId = string | null;

const useAnchorMenu = () => {
  const [activeAnchor, setActiveAnchor] = useState<AnchorId>(null);

  useEffect(() => {
    const handleAnchorChange = (event: CustomEvent<AnchorId>) => {
      const anchorId = event.detail;

      setActiveAnchor(`#${anchorId}`);
    };

    window.addEventListener(
      'activeAnchorChange',
      handleAnchorChange as EventListener,
    );

    return () => {
      window.removeEventListener(
        'activeAnchorChange',
        handleAnchorChange as EventListener,
      );
    };
  }, []);

  const changeActiveAnchor = (anchor: AnchorId) => {
    const activeAnchorChangeEvent = new CustomEvent('activeAnchorChange', {
      detail: anchor,
    });

    window.dispatchEvent(activeAnchorChangeEvent);
  };

  return { activeAnchor, setActiveAnchor: changeActiveAnchor };
};

export default useAnchorMenu;
